import { defineMessages } from 'react-intl'

const scope = `procurify.modules.reports.pages.ReportExportHistoryPage`

export default defineMessages({
  pageTitle: {
    id: `${scope}.pageTitle`,
    defaultMessage: 'Report export history',
  },
})
